<template lang="pug">
  div
    validation-observer(ref='validation' tag='form')
    div(v-if="isCadastroPendente")
      app-divider(label="Vinculação Automática").margin-bottom
      el-row(:gutter="30").margin-bottom
        el-col(:span="12")
          validation-provider(rules="required|cpf_cnpj", v-slot="{ errors }")
            app-label(label="CPF/CNPJ do Interessado:")
            el-input.input(
              v-model='cadastroGeo.interessadoCpfCnpj',
              :class="{'erro' : errors.length}"
              v-mask="['###.###.###-##', '##.###.###/####-##']"
            )
            span.help.erro {{ errors[0] }}
        el-col(:span="12")
          validation-provider(rules="required", v-slot="{ errors }")
            app-label(label="Data da Medição:", :required = "true")
            el-date-picker.input.full-width(
              v-model="cadastroGeo.dataMedicao",
              type="date",
              format="dd/MM/yyyy",
              placeholder="Selecione",
              :picker-options="pickerOptions",
              :class="{'erro' : errors.length}"
              )
            span.help.erro {{ errors[0] }}
    app-divider(:label="!isBahia ? 'Responsável' : 'Responsável Técnico'").margin-bottom
    el-row(:gutter="30").margin-bottom
      el-col(:span="12")
        validation-provider(rules="required", v-slot="{ errors }")
          app-label(label="Nome:")
          el-input.input(
            v-model='responsavel.nome',
            :value='responsavel.nome',
            :class="{'erro' : errors.length}"
            maxlength="100"
          )
          span.help.erro {{ errors[0] }}

      el-col(:span="12")
        validation-provider(rules="required", v-slot="{ errors }")
          app-label(label="Formação:")
          el-input.input(
            v-model='responsavel.formacao',
            :value='responsavel.formacao',
            :class="{'erro' : errors.length}"
            maxlength="100"
          )
          span.help.erro {{ errors[0] }}

    div(v-if="estado === 'ba'").margin-bottom
      el-row(:gutter="30")
        el-col(:span="4")
          validation-provider(rules="required", v-slot="{ errors }")
            app-label(label="Conselho de classe:")
            el-select.input(
              v-model='responsavel.conselhoClasse',
              :value='responsavel.conselhoClasse',
              :class="{'erro' : errors.length}"
              maxlength="100"
            )
              el-option(
                v-for="item in listaConselhos"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              )
            span.help.erro {{ errors[0] }}
        el-col(:span="10")
          validation-provider(rules="required", v-slot="{ errors }")
            app-label(label="Código do conselho de classe:")
            el-input.input(
              v-model='responsavel.creaRnp',
              :value='responsavel.creaRnp',
              :class="{'erro' : errors.length}"
              maxlength="100"
            )
            span.help.erro {{ errors[0] }}
        el-col(:span="10")
          validation-provider(rules="required", v-slot="{ errors }")
            app-label(label="Código de credenciamento no INCRA:")
            el-input.input(
              v-mask="'XXXX'",
              v-model='responsavel.codigoIncra',
              :value='responsavel.codigoIncra',
              :class="{'erro' : errors.length}"
              maxlength="100"
            )
            span.help.erro {{ errors[0] }}
    el-row(v-if="estado !== 'ba'" :gutter="30" )
      el-col(:span="8")
        validation-provider(rules="required", v-slot="{ errors }")
          app-label(label="RNP:")
          el-input.input(
            v-model='responsavel.creaRnp',
            :value='responsavel.creaRnp',
            :class="{'erro' : errors.length}"
            maxlength="100"
          )
          span.help.erro {{ errors[0] }}
      div
        el-col(:span="12")
          validation-provider(:rules="{required: !isPA}", v-slot="{ errors }")
            app-label(label="Código de credenciamento no INCRA:" :required="!isPA" )
            el-input.input(
              v-mask="'XXXX'",
              v-model='responsavel.codigoIncra',
              :value='responsavel.codigoIncra',
              :class="{'erro' : errors.length}"
              maxlength="100"
            )
            span.help.erro {{ errors[0] }}

</template>
<script>
import AppDivider from '@/components/AppDivider'
import AppLabel from '@/components/AppLabel'
const { conselhos } = require('@/utils/' + process.env.ESTADO + '/regrasAnalise').default

export default {
  components: {
    AppLabel,
    AppDivider
  },
  props: {
    responsavel: {
      type: Object
    },
    processo: {
      type: Object,
      required: false
    },
    isCadastroPendente: {
      type: Boolean,
      default: false
    },
    cadastroGeo: {
      type: Object
    }
  },
  data () {
    return {
      estado: process.env.ESTADO,
      isPA: process.env.ESTADO === 'pa',
      listaConselhos: conselhos,
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now()
        }
      }
    }
  },

  computed: {
    isBahia () {
      return process.env.ESTADO === 'ba'
    }
  }
}
</script>
<style scoped>
  .margin-bottom {
    margin-bottom: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/shared/AppDadosResponsavel.vue